import { render, staticRenderFns } from "./VerificationsDetail.vue?vue&type=template&id=5241c9ad&scoped=true&"
import script from "./VerificationsDetail.vue?vue&type=script&lang=js&"
export * from "./VerificationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./VerificationsDetail.vue?vue&type=style&index=0&id=5241c9ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241c9ad",
  null
  
)

export default component.exports